export const formatDate = (dateString, formatType = "MMM-YYYY") => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date"; // Handle invalid dates

    const options = {
        "MMM-YYYY": { month: "short", year: "numeric" }, // "Dec-2024"
        "MM-DD-YYYY": { month: "2-digit", day: "2-digit", year: "numeric" }, // "12-25-2024"
        "DD-MM-YYYY": { day: "2-digit", month: "2-digit", year: "numeric" }, // "25-12-2024"
        "YYYY-MM-DD": { year: "numeric", month: "2-digit", day: "2-digit" } // Default format
    };

    const format = options[formatType] || options["MMM-YYYY"];

    return new Intl.DateTimeFormat("en-US", format)
        .format(date)
        .replace(",", "")
        .replace(/(\d+) (\w+)/, "$2-$1"); // Adjust for "MMM-YYYY"
};
